module.exports = __webpack_public_path__ + "img/129d6c9.png";